import { createSelector } from '@reduxjs/toolkit';

import { selectOffer } from './offerData';

export const selectIsEarlyAccessLabelEnabled = createSelector(selectOffer, offer => offer.isEarlyAccessEnabled);
